import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  OnDestroy,
  ViewChildren,
  QueryList,
  HostListener,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import * as _ from 'lodash';

import { Segment } from '../segment.interface';
import { TabButtonDirective } from 'shared/button/tab-button.directive';


@Component({
  moduleId: module.id,
  selector: 'segments-navigation-v2',
  templateUrl: 'segments-navigation-v2.component.html',
  styleUrls: ['segments-navigation-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentsNavigationV2Component implements OnChanges {
  @Input() segments: Array<Segment> = [];
  @Input() navAlign: string = 'justified'; // ['justifyed', 'fill']

  @Output() selected = new EventEmitter<any>();

  constructor(
    private ref: ChangeDetectorRef,
  ) {}

  ngOnChanges() {
    this.setSegmentsNames();
    this.ref.markForCheck();
  }

  onNavButtonClick(segment: Segment) {
    if (segment.disabled) { return; }
    this.setActive(segment.name);
    this.selected.emit(segment);
  }

  public setActive(name: string): void {
    _.forEach(this.segments, (segment: Segment, index: number) => {
      segment.active = (segment.name === name);
    });
    this.ref.markForCheck();
  }

  public toggleCircle(name: string, toggle?: boolean) {
    this.segments.some((segment: Segment) => {
      if (segment.name === name) {
        segment.circleIcon = !!toggle;
        return true;
      }
      return false;
    });
    this.ref.markForCheck();
  }

  public toggleCircles(func: Function): void {
    _.each(this.segments, (segment: any) => {
      segment.circleIcon = func.call(this, segment);
    });
    this.ref.markForCheck();
  }

  private segmentName(title: string): string {
    return title.replace(/\s/g, '-').toLowerCase();
  }

  private setSegmentsNames(): void {
    this.segments.forEach((segment: Segment) => {
      if (!segment.name) { segment.name = this.segmentName(segment.title); }
    });
  }

}
